import React, { ReactElement, useEffect } from 'react';
import {
  Breadcrumbs, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { Button, Heading, Loader } from 'idsk-react-components';
import iconRss from '../../../assets/images/icon-rss.svg';
import routes from '../../routing/routes';
import Layout from '../Layout';
import GlobalErrors from '../../module/GlobalErrors';
import PrispevokVestnikaList from '../../module/PrispevokVestnikaList';
import useFilterFromUrl from '../../module/PrispevokVestnikaList/hooks/useFilterFromUrl';
import './prispevokVestnikaListPage.scss';
import externalRoutes from '../../routing/externalRoutes';

const PrispevokVestnikaListPage = (): ReactElement => {
  const { initialFilter, initialFilterLoading } = useFilterFromUrl();

  useEffect(() => {
    setTitle('Rezortné zbierky');
  }, []);

  return (
    <Layout>
      <Breadcrumbs
        routeList={[
          homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
          {
            to: routes.prispevokVestnika.list.to,
            heading: routes.prispevokVestnika.list.name,
          },
        ]}
      />
      <GlobalErrors />
      <>
        <div className="rezortne-zbierky-page-heading">
          <Heading size="xl" className="page-title">
            <span>
              Rezortné zbierky
            </span>
            <Button
              className="rss_button"
              buttonStyle="link"
              iconBefore={iconRss}
              size="extra-small"
              onClick={() => {
                window.parent.postMessage({
                  type: 'iframe-to-parent-absolute-url',
                  route: externalRoutes.rss,
                  newTab: true,
                }, '*');
              }}
            >RSS
            </Button>
          </Heading>
        </div>
        <Loader loading={initialFilterLoading}>
          {initialFilter && !initialFilterLoading && (
            <PrispevokVestnikaList initialFilter={initialFilter} />)}
        </Loader>
      </>
    </Layout>
  );
};

export default PrispevokVestnikaListPage;
